import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';
import { useCallback } from 'react';
import FilterContainer from '../../../../Tracking/components/NFFilters/components/FilterContainer';
import { cpfOrCnpjMask, customersMask } from '../../../../Tracking/components/NFFilters/masks';
import { luftGet } from '../../../../../shared/http';
import FilterForm from '../../../../Tracking/components/NFFilters/components/FilterForm';
import CheckboxControl from '../../../../Tracking/components/NFFilters/components/CheckboxControl';
import InfinityContent from '../../../../Tracking/components/NFFilters/components/InfinityContent';
import Mask from '../../../../../utils/Mask';

const CarrierList = ({
  isOpen,
  onClick,
  onApply,
  byDate,
  initialPeriod,
  finalPeriod,
  carrierList,
  value,
}) => {
  const [selectedItem, setSelectedItem] = useState(carrierList);
  const [atualPage, setAtualPage] = useState(1);
  const [data, setData] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [queryParamas, setQueryParams] = useState();
  const [totalLines, setTotalLines] = useState();

  useEffect(() => {
    if(carrierList?.length < 1) {
      setSelectedItem([]);
    }
  }, [carrierList]);

  const companyId =
    window.localStorage.getItem('Luft/CustomerService/CompanyId') ||
    window.localStorage.getItem('Luft/CompanyId');

  const params = {
    page: atualPage,
    amount: 10,
    byDate,
    initialPeriod,
    finalPeriod,
    companyId,
  };

  const fetchAllShippingCompanies = async () => {
    if (loading) {
      return;
    }
    try {
      setLoading(true);

      const response = await luftGet(
        '/ShippingCompany/Get',
        params,
      );

      setData(prevData => [...prevData, ...response.data]);
      setTotalLines(data.length);
      setAtualPage(prevPage => prevPage + 1);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setAtualPage(0);
    setData([]);
    fetchAllShippingCompanies();
  }, [byDate, initialPeriod, finalPeriod]);

  const handleSearchByCustomer = async e => {
    e.preventDefault();
    setQueryParams(Mask.numbers(e.target.value));
    await debounceFilteredCustomers(e);
  };

  const fetchFilterByCustomer = async e => {
    setLoading(true);
    try {
      const newParams = {
        ...params,
        page: 1,
        query: e.target.value.toLocaleLowerCase().trim(),
      };

      const response = await luftGet(
        '/ShippingCompany/Get',
        newParams,
      );
      setDataFilter(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const debounceFilteredCustomers = useCallback(
    debounce(fetchFilterByCustomer, 1000),
    [],
  );

  const handleChange = e => {
    if (!e.target.checked) {
      setSelectedItem(
        selectedItem.filter(item => Mask.numbers(item) !== Mask.numbers(e.target.value)),
      );
    } else if (e.target.checked) {
      setSelectedItem([...selectedItem, Mask.numbers(e.target.value)]);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    const displayValue = selectedItem.map(item => {
      const found = data.find(filter => Mask.numbers(filter.cnpj) === Mask.numbers(item));
      return found ? customersMask(found.corporateName) : item;
    })[0];
    onApply({carrierList:selectedItem, displayValue})
  };

  const clearFilter = () => {
    setSelectedItem([]);
    onApply({carrierList: [], displayValue: ''});
  };

  const clearSearch = () => {
    setQueryParams('');
  };

  return (
    <FilterContainer
      label="Transportadora"
      isOpen={isOpen}
      onClick={onClick}
      alignDropdownRight
      value={value}
    >
      <FilterForm
        label="Filtrar por transportadora"
        onSubmit={handleSubmit}
        clearFilter={clearFilter}
      >
        <InfinityContent
          inputSearchLabel="Buscar transportadora"
          searchChange={handleSearchByCustomer}
          clearSearch={clearSearch}
          data={data}
          dataFiltered={dataFilter}
          fetchAllData={() => fetchAllShippingCompanies()}
          hasMore={
            dataFilter.length !== 0
              ? dataFilter.length < totalLines
              : data.length < totalLines
          }
          queryParamas={queryParamas}
          loading={loading}
        >
          {(queryParamas ? dataFilter : data).map(filter => {
            if (filter.cnpj) {
              return (
                <CheckboxControl
                  key={filter.id}
                  value={filter.cnpj}
                  onChange={handleChange}
                  defaultChecked={selectedItem.some(
                    item => Mask.numbers(item) === Mask.numbers(filter.cnpj),
                  )}
                  title={customersMask(filter.corporateName ?? 'N/A')}
                  description={cpfOrCnpjMask(filter.cnpj.trim())}
                  infinityList
                />
              );
            }
          })}
        </InfinityContent>
      </FilterForm>
    </FilterContainer>
  );
};

const mapStateToProps = state => {
  return {
    carrierList: state.dashboardFilters.filters.carrierList,
    byDate: state.dashboardFilters.filters.byDate,
    initialPeriod: state.dashboardFilters.filters.initialPeriod,
    finalPeriod: state.dashboardFilters.filters.finalPeriod,
  };
};

export default connect(mapStateToProps)(CarrierList);
